import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.show(this.tabTargets.find((t) => t.dataset.day === "today"))
  }

  switch(event) {
    event.preventDefault()
    this.show(event.currentTarget)
  }

  show(activeTab) {
    if (!activeTab) return

    const activeDay = activeTab.dataset.day

    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.day === activeDay
      tab.classList.toggle("ring-2", isActive)
      tab.classList.toggle("ring-blue-600", isActive)
      tab.classList.toggle("border-blue-600", isActive)
      tab.classList.toggle("bg-blue-50", isActive)
      tab.classList.toggle("scale-[0.98]", isActive)
    })

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.day !== activeDay)
    })
  }
}
